import React, { useCallback, useEffect, useRef, useState } from 'react'
import Maps from '../../components/master/Maps'
import SearchablePicker from '../../components/master/SearchablePicker'
import { pexios, toast } from '../../utils/functions';
import { history } from '../../utils/variables';
import { useDispatch, useSelector } from 'react-redux';
import { setLocation } from '../../redux/actions';
import Modal from '../../components/master/Modal';
import HeaderIcon from '../../assets/images/header-icon/map.png'
function GetLocation({type = 'free',submitRegister,changeStep}) {
    const dispatch = useDispatch();
    const { location ,routerData } = useSelector(store => store);
    const [states,setStates] = useState([{id : 0 , title : '',cities: [{id : 0 , title : ''}]}])
    const [loader, setLoader] = useState(false);
    const [locationAccess, setLocationAccess] = useState(false);
    const [step,setStep] = useState('screen')
    const [data,setData] = useState({
        state: '',
        city: '',
        address:'',
        lat : location.lat,
        lng : location.lng
    })
    const prevLocation = useRef({
        latitude: null,
        longitude: null,
    });
    const [loadingPsition,setLoadingPosition] = useState(false)
    function findLoacation () {
        if(navigator.geolocation) {
            setLoadingPosition(true)
            navigator.geolocation.getCurrentPosition((loc)=>{
                const lat = loc.coords.latitude;
                const lng = loc.coords.longitude;
                 if(
                    data.lat !==  lat||
                    data.lng !== lng
                ) {
                    pexios('/api/get_address','post',{lng:lng,lat:lat})
                    .then((res)=>{
                        const response = res.data
                        setData({
                            lat:lat,
                            lng:lng,
                            state : response.state?.id || '',
                            city : response.city?.id || '',
                            address : response.address || ''
                        })
                        setLoadingPosition(false)
                    })
                }
             },()=> setLoadingPosition(false))
         }
    }
    function findAddress (lat,lng){
        if( 
            prevLocation.current.latitude !== lat ||
            prevLocation.current.longitude !== lng
        ){
        pexios('/api/get_address','post',{lng:lng,lat:lat})
        .then((res)=>{
            const response = res.data
            setData({
                lat:lat,
                lng:lng,
                state : response.state?.id || '',
                city : response.city?.id || '',
                address : response.address || ''
            })
            // setChangeManuual(false)
        })
        prevLocation.current = {
            latitude: lat,
            longitude: lng,
        }
        }
    }
    const currentLocation = useCallback(()=>{
        const fetchLocation = ()=> {
            if(navigator.geolocation) {
               navigator.geolocation.getCurrentPosition((loc)=>{
                    findAddress(loc.coords.latitude,loc.coords.longitude)
                    !locationAccess && setLocationAccess(true)
                },()=>{
                    data.lat !== 35.696747 && data.lng !== 51.378444 && findAddress(data.lat,data.lng)
                })
            }else {
                data.lat !== 35.696747 && data.lng !== 51.378444 && findAddress(data.lat,data.lng)
            }
        }
        fetchLocation()
    },[])
    useEffect(()=>{
        // let accessLoc = false
        
        setLoader(true)
        pexios('api/get_states')
        .then((res)=>{
            setStates(res.data);
            // !(!await locationAccess() && data.lat === 35.696747 && data.lng === 51.378444) && findLocation()
            // watchPosition = navigator.geolocation.watchPosition((loc) => {
            // // setData(prevState => ({
            // //     ...prevState,
            // //     lat: loc.coords.latitude,
            // //     lng: loc.coords.longitude
            // // }));
            // findLocation(loc.coords.latitude,loc.coords.longitude)
            // accessLoc = true
            // })
            currentLocation()
            setLoader(false)
        })
        // .then(()=>{
        //     (!accessLoc && data.lat !== 35.696747 && data.lng !== 51.378444) && findLocation(data.lat,data.lng)
        //     setLoader(false)
        // })
        },[])
    // useEffect(()=>{
    //     changeManuual && setData({...data,city : 0,address:''})
    // },[data.state])
    // useEffect(()=>{
    //     dispatch(setLocation({
    //         lat: data.lat,
    //         lng: data.lng,
    //         state_id : data.state,
    //         city_id : data.city
    //     }));
    // },[data.city,data.location])
    
    // useEffect(()=>{
        // setLoader(true)
        // setTimeout(()=>findLocation(),500)
    // },[])
    //data.location dep
    function changeData(value, name) {
        switch (name) {
            case 'city':
                setData(prevState => ({
                    ...prevState,
                    [name] : value,
                    lat: states[(data.state)-1]['cities'].filter(item=>item.id === value)[0]?.lat || data.lat,
                    lng: states[(data.state)-1]['cities'].filter(item=>item.id === value)[0]?.lng || data.lng,
                    // state_id : data.state,
                    // city_id : value,
                    address :''
                }))
                break;
            case 'state':
                setData(prevState => ({
                    ...prevState,
                    [name] : value,
                    city: '',
                    address :''
                }))
                break;
            case 'location':
                setData(prevState => ({
                    ...prevState,
                    ...value
                }))
                break;
            default:
                setData(prevState => ({
                    ...prevState,
                    [name]: value,
                }));
        }
        // name === 'city' ?
        // setData(prevState => ({
        //     ...prevState,
        //     [name] : value,
        //     lat: states[(data.state)-1]['cities'].filter(item=>item.id === value)[0]?.lat || data.lat,
        //     lng: states[(data.state)-1]['cities'].filter(item=>item.id === value)[0]?.lng || data.lng,
        //     // state_id : data.state,
        //     // city_id : value,
        //     address :''
        // }))
        // : name === 'state'?
        // setData(prevState => ({
        //     ...prevState,
        //     [name] : value,
        //     city: 0,
        //     address :''
        // }))
        // :
        // setData(prevState => ({
        //     ...prevState,
        //     [name]: value,
        // }));
        // setChangeManuual(true)
    }
    // function changeLocation(e) {
    //     changeData({
    //         lat: e.lat,
    //         lng: e.lng,
    //     },'location');
    // }
    function submit() {
        if(type === 'special') {
            // const post_data = {
            //     state_id : data.state,
            //     city_id : data.city,
            //     address : data.address,
            //     ...data.location
            // }
            pexios('/api/special_request','post',data)
            .then((res)=>{
                if(res.data.type === 'new'){
                    toast('درخواست شما ثبت شد. در اسرع وقت با شما تماس گرفته خواهد شد .');
                }else {
                    toast('درخواست قبلی شما در حال بررسی است .در اسرع وقت با شما تماس گرفته خواهد شد . از صبوری شما متشکریم .');
                }

            })
            setTimeout(()=>history.push('/'),5000);
        }
        else {
            dispatch(setLocation({
                lat: data.lat,
                lng: data.lng,
                state_id : data.state,
                city_id : data.city,
                address : data.address
            }));
            history.push('/assess-type');
        }
    }
    function handleLocation() {
        findAddress(data.lat,data.lng)
        setStep('screen')
    }
  return (
    <>
    {step === 'full-screen' && 
    <div className='full-screen-map'>
        <Maps
            loc={[
                data?.lat,
                data?.lng,
            ]}
            changeLocation={(e)=>changeData({lat : e.lat,lng : e.lng},'location')}
        />
        <div className='d-flex justify-center submit-btn mx20'>
        <button 
            className={` btn btn-circle mt20 w-50 btn-white-purple btn-bold mx5`} 
            onClick={handleLocation}>تایید موقعیت 
        </button>
        {locationAccess && <button 
            className={`btn btn-circle mt20 w-50 btn-white-purple btn-bold mx5`} 
            disabled={loadingPsition}
            onClick={findLoacation}>
                {loadingPsition ? <i className='fas fa-spinner fa-spin' /> : 'موقعیت فعلی'} 
        </button>}
        </div>
        <span className='resize-btn' onClick={handleLocation}><i className='fas fa-compress'/></span>
    </div>
    }
    {step !== 'full-screen' && 
    <div className='content map pb20'>
        {loader&&
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <i className='fas fa-spinner fa-spin'/>
                </div>
            </Modal>
        }
        <div className='title-image'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        <p className='guide-text mx10 mt10'>
            {routerData.type === 'register' ? 
            'کاربر محترم لطفا آدرس و موقعیت مکانی خودرو خود را روی نقشه تعیین نمایید.'
            :
            'کاربر محترم تشکیل پرونده شما با موفقیت انجام شده است. لطفا آدرس و موقعیت مکانی خودرو خود را روی نقشه ، جهت اعزام کارشناس و بازدید خودرو تعیین نمایید.'
            }
        </p>
        {/* <p className='mt10 sub-title' style={{fontSize: '12px'}}> 
            {type === 'special' ? 'مکان دریافت خدمات کارشناسی خود را مشخص نمایید .' :' مکان بازدید خودرو توسط کارشناس را مشخص نمایید .'}
        </p> */}
        <div className='map-box'>
            <Maps 
                loc={[
                    data?.lat,
                    data?.lng,
                ]}
                // changeLocation={(e)=>changeData({lat : e.lat,lng : e.lng},'location')}
            />
            <span className='btn btn-white-purple resize-btn' onClick={()=>setStep('full-screen')}>
                {/* <i className='fas fa-expand'/> */}
                تعیین مکان روی نقشه
                </span>
        </div>
        <div className='row from text-right'>
            <SearchablePicker
                data={states}
                label='استان'
                value={data.state}
                titleKey='title'
                valueKey='id'
                rtl
                // required
                onSelect={val => changeData(val, 'state')}
            />
            <SearchablePicker
                // data={(data.state)-1 < 0 ? []:states[(data.state)-1]['cities'] ||[]}
                data={!data.state ? [{id : 0 , title : ''}]:states[(data.state)-1]['cities']}
                label='شهر'
                value={data.city}
                titleKey='title'
                valueKey='id'
                rtl
                // required
                onSelect={val => changeData(val, 'city')}
            />
        </div>
        <label className='d-flex mt10 mr5'>آدرس</label>
        <div className='input-parent'>
            <textarea
                className='p10 mt10 ml5 mr5 text-area text-right'
                type='text'
                value={data.address}
                placeholder='آدرس'
                onChange={e => changeData(e.target.value,'address')}
            />
        </div>
        {
            routerData.type === 'register'?
            <div className='d-flex justify-center'> 
                <button 
                    className={`btn btn-circle mt20 btn-block btn-orange ml10 mr10`} 
                    onClick={changeStep}>
                        برگشت  
                </button>
                <button 
                    className={`btn btn-circle mt20 btn-block ml10 mr10 ${data.state && data.city && data.address ? 'btn-white-purple btn-bold' :'btn-disable'}`} 
                    disabled={!(data.state && data.city && data.address)} 
                    onClick={submitRegister}> شروع تصویربرداری  </button>
            </div>
            :
            <div className='d-flex justify-center'>
                {type === 'special' &&
                <button 
                    className={`btn btn-circle mt20 btn-block btn-orange ml10 mr10`} 
                    onClick={()=>history.push("/")}>
                        انصراف  
                </button>
                }
                <button 
                    className={`btn btn-circle mt20 btn-block ml10 mr10 ${data.state && data.city && data.address ? 'btn-white-purple btn-bold' :'btn-disable'}`} 
                    disabled={!(data.state && data.city && data.address)} 
                    onClick={submit}> {type === 'special' ? 'ثبت': 'مرحله بعد'}  </button>
            </div>
        }
    </div>
    }
    </>
  )
}

export default GetLocation